import useDevice from 'hooks/useDevice';
import { useState } from 'react';
import {
  useChangeEmailNotificationEnabledMutation,
  useGetLoginMethodsQuery,
} from 'store/slices/profile-api';
import { loginTypes } from 'utils/constants';
import LegalNavigation from './LegalNavigation/LegalNavigation';
import ProfileNavigation from './ProfileNavigation/ProfileNavigation';
import ProfileView from './ProfileView/ProfileView';

export default function ProfileComponent() {
  const mobileDevice = useDevice();
  const [changeEmailNotificationEnabled] =
    useChangeEmailNotificationEnabledMutation();
  const [state, setState] = useState(false);
  const [showDisabledEmailModal, setShowDisabledEmailModal] = useState(false);

  const { data: loginMethodsData } = useGetLoginMethodsQuery();

  function closeModal() {
    setState(false);
  }

  function toggleDisabledEmailModal() {
    setShowDisabledEmailModal(!showDisabledEmailModal);
  }

  function toggleLoginNotifications(
    newValue: boolean,
    modalConfirmed: boolean,
  ): void {
    if (newValue) {
      changeEmailNotificationEnabled(true);
    } else if (!modalConfirmed) {
      setState(true);
    } else {
      changeEmailNotificationEnabled(false);
      closeModal();
    }
  }

  return (
    <div className="flex flex-col">
      <div className="flex space-x-0 lg:space-x-8 mt-4 flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 ">
          <ProfileView
            showModal={state}
            closeModal={closeModal}
            toggleLoginNotifications={toggleLoginNotifications}
          />
        </div>
        <div className="w-full lg:w-1/2 flex flex-col space-y-4">
          <ProfileNavigation
            hasPassword={loginMethodsData?.some(
              method => method.type === loginTypes.PASSWORD && method.enabled,
            )}
            showDisabledEmailModal={showDisabledEmailModal}
            toggleDisabledEmailModal={toggleDisabledEmailModal}
          />
        </div>
        {mobileDevice.isDeviceMobile && (
          <div className="w-full lg:w-1/2 flex flex-col space-y-4">
            <LegalNavigation />
          </div>
        )}
      </div>
      {/* NOTE: this div has just been added for padding, because of the Crisp button overlaying the content */}
      <div className="pb-28 w-full transparent" />
    </div>
  );
}
